var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"brand-ambient-glow glow-top"}),_c('div',{staticClass:"brand-ambient-glow glow-middle"}),_c('div',{staticClass:"brand-ambient-glow glow-bottom"}),_c('div',{staticClass:"brand-ambient-rings"}),_c('div',{staticClass:"app-main-content"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }